/*
  Сообщения реестра по карточке, выбранной человеком (23.10.2026) - второй шаг
  обмена со службой «Арбитр Сведения»: при вопросе только по ФИО служба отдаёт
  одни карточки, и выбранную спрашивают снова по её номеру. Запрос, затем опрос
  хода, пока служба не ответит; правила опроса - те же, что у проверки счёта
  (`registryPolling.js`).
*/

import { useEffect, useState } from 'react'

import { api } from '../api/client.js'
import { isTemporary, POLL_LIMIT, POLL_MS } from './registryPolling.js'

export default function useRegistryMessages(accountId, checkId, guid) {
  const [result, setResult] = useState(null)
  const [busy, setBusy] = useState(false)
  const [failure, setFailure] = useState(null)
  const [polls, setPolls] = useState(0)

  useEffect(() => {
    if (!result || result.done || polls >= POLL_LIMIT) return undefined
    // Ответ опроса, ушедшего до нового запроса, выбрасывается (причина 5 аудита 26.10.2026).
    let current = true
    const timer = setTimeout(async () => {
      try {
        const answer = await api.registryMessages(accountId, result.check_id)
        if (!current) return
        setResult(answer)
        setFailure(null)
        setPolls(polls + 1)
      } catch (error) {
        if (!current) return
        setFailure(error)
        setPolls(isTemporary(error) ? polls + 1 : POLL_LIMIT)
      }
    }, POLL_MS)
    return () => {
      current = false
      clearTimeout(timer)
    }
  }, [accountId, result, polls])

  async function ask() {
    setBusy(true)
    setFailure(null)
    setPolls(0)
    try {
      setResult(await api.requestRegistryMessages(accountId, checkId, guid))
    } catch (error) {
      setFailure(error)
    } finally {
      setBusy(false)
    }
  }

  const running = Boolean(result && !result.done && polls < POLL_LIMIT)
  return { result, busy, failure, running, ask }
}
